'use client';

import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';

interface DocumentationCategoryCardProps {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
  docCount: number;
  href: string;
  className?: string;
}

export function DocumentationCategoryCard({
  title,
  description,
  icon: Icon,
  docCount,
  href,
  className,
}: DocumentationCategoryCardProps) {
  return (
    <Link to={href}>
      <Card
        className={cn(
          'cursor-pointer hover:border-primary/50 hover:shadow-md transition-all group h-full',
          className
        )}
      >
        <CardContent className="pt-6">
          <div className="flex items-start gap-4">
            <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <Icon className="size-6 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-semibold group-hover:text-primary transition-colors">
                  {title}
                </h3>
                <ChevronRight className="size-4 text-muted-foreground group-hover:text-primary transition-colors shrink-0" />
              </div>
              <p className="text-sm text-muted-foreground line-clamp-2 mt-1">
                {description}
              </p>
              <Badge variant="secondary" className="text-xs mt-3">
                {docCount} {docCount === 1 ? 'doc' : 'docs'}
              </Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
